const MuiPopover = {
  defaultProps: {
    elevation: 7,
  },
};

export default MuiPopover;
